import { createAction } from 'redux-actions';

import mapActions from '@goodwaygroup/react-map-actions';

// Actions
export const actions = mapActions([
    'PAGE_VIEW',
], 'TRACKING');

// Action Creators
export const pageView = createAction(actions.PAGE_VIEW);



// WEBPACK FOOTER //
// ./src/services/tracking/duck.js